// sections/ContractorSignupSection.tsx
import React from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { DollarSign, Users, PenTool as Tool } from "lucide-react";

const ContractorSignupSection: React.FC = () => {
  const benefits = [
    {
      icon: DollarSign,
      description: "Access quality leads in your area",
    },
    {
      icon: Users,
      description: "Build your online reputation",
    },
    {
      icon: Tool,
      description: "Free project management tools",
    },
  ];

  const successStories = [
    {
      name: "Mike Johnson",
      business: "MJ Construction",
      quote: "Increased my business by 40% in the first year",
    },
    {
      name: "Lisa Chen",
      business: "Modern Renovations",
      quote: "Found quality clients and grew my team",
    },
  ];

  return (
    <section className="py-5 bg-dark-blue text-white">
      <Container>
        <Row className="align-items-center">
          <Col md="6" className="mb-4 mb-md-0">
            <h2 className="fs-1 fw-bold mb-4">Are You a Contractor?</h2>
            <p className="fs-4 mb-4">
              Join our network of trusted professionals and grow your business
            </p>
            <div className="mb-4">
              {benefits.map((benefit, index) => (
                <div className="d-flex align-items-center mb-3" key={index}>
                  <benefit.icon className="me-3 text-white" />
                  <span>{benefit.description}</span>
                </div>
              ))}
            </div>
            <Link to="/register">
              <Button
                color="warning"
                className="px-4 py-2 fw-semibold text-dark"
              >
                Join as a Pro
              </Button>
            </Link>
          </Col>
          <Col md="6">
            <Card className="text-dark">
              <CardBody className="p-4">
                <h3 className="fs-3 fw-bold mb-4">Success Stories</h3>
                <div>
                  {successStories.map((story, index) => (
                    <div
                      key={index}
                      className="border-start border-3 border-primary ps-3 mb-4"
                    >
                      <p className="text-muted mb-2">"{story.quote}"</p>
                      <div className="fw-semibold">{story.name}</div>
                      <div className="small text-muted">{story.business}</div>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContractorSignupSection;